let url = ''
let urls = ''
let openurl=''
let pdf = 'http://202.130.113.149/khadmin/pdfView/views/'
let connection =''
let times = 200000
if (location.host == '202.130.113.149') { //正式
	url = 'http://202.130.113.149:3785/'; //正式
	openurl = 'http://202.130.113.149/khadmin/#/downitem'
	urls = 'http://202.130.113.149:3789/qmisweb/';
	connection = 'http://202.130.113.149:6609';
	times = 2000;

} else { //測試 localhost
	// url = 'http://47.243.50.48:3785/'; //測試
	// connection = 'http://47.243.50.48:6609';
	// urls = 'http://47.243.50.48:3789/qmisweb/';
	url = 'http://202.130.113.149:3785/'; //測試
	connection = 'http://202.130.113.149:6609';
	urls = 'http://202.130.113.149:3789/qmisweb/';
	
	// url = 'http://192.168.31.238:3785/';
	// connection = 'http://192.168.31.238:6609';  //本地
	// urls = 'http://192.168.31.238:3789/qmisweb/';
	
	
	openurl = location.origin + '/#/downitem'
	times = 200000
}
if(location.protocol == 'https:'||location.host == 'hk.qmisit.com'){
	times = 30000
	connection= 'https://hk.qmisit.com:6609';
	pdf = 'https://hk.qmisit.com/qmisadmin/pdfView/views/'
	url = 'https://hk.qmisit.com:3785/'; //正式
	urls = 'https://hk.qmisit.com:3789/qmisweb/';
	openurl = location.origin + '/qmisadmin/#/downitem'
}

module.exports = {
	newUserApplyAudit:url + 'admin/newUserApplyAudit',
	getUserApplyRecordWithApplyid:url + 'admin/getUserApplyRecordWithApplyid',
	getUserApplyRecordList:url + 'admin/getUserApplyRecordList',
	getQmisUserTCPdf:url + 'admin/getQmisUserTCPdf',
	getTalkingRecordGroupWithRoomid:url + 'admin/getTalkingRecordGroupWithRoomid',
	newAdminHandle:url + 'admin/newAdminHandle',
	newSuperAdminRemarks:url + 'admin/newSuperAdminRemarks',//備註查詢
	getSuperAdminRemarks:url + 'admin/getSuperAdminRemarks',//備註查詢
	getAdminHandleLogsWithAdminid:url + 'admin/getAdminHandleLogsWithAdminid',//個人日誌查詢 POST
	getAllAdminHandleLogs:url + 'admin/getAllAdminHandleLogs',
	readyToCloseRoom:url + 'admin/readyToCloseRoom',
	getQmisAdministrativeContractPdf:url + 'admin/getQmisAdministrativeContractPdf',
	getQmisUserLoginLogsPdf:url +'admin/getQmisUserLoginLogsPdf',
	getQmisUserLoginLogs:url +'admin/getQmisUserLoginLogs',
	times,
	newIpoSellingAudit:url +'admin/newIpoSellingAudit',
	//定时器
	getNoReadMsgNumber:url + 'admin/getNoReadMsgNumber',
	//移動系統pdf
	getMobileserviceListPdf:url + 'admin/getMobileserviceListPdf',
	//供應列表pdf
	getGongYingListPdf:url + 'admin/getGongYingListPdf',
	//域名列表pdf
	getDoMainnameListPdf:url + 'admin/getDoMainnameListPdf',
	connection : connection,
	pdfs:pdf + 'jqypdfView.html?url=',
	cspdf:pdf + 'pdfView.html?url=',
	openurls:openurl,
	adminurls : urls + 'command',
	sendWithdrawRemittanceEmail:urls + 'sendWithdraw',
	getOrderHistoryExcel : url + 'papertrading/getOrderHistoryExcel',//导出ex表格
	getOrderHistoryPdf:urls +'getOrderHistoryPdf',
	url: url,
	// 登錄接口
	adminlogin: 'admin/adminlogin',
	isNoUseBank: 'admin/isNoUseBank',
	// 首頁統計
	firstPageStatistics: 'admin/firstPageStatistics',
	// 開戶管理進度統計接口
	getProgress: 'admin/getProgress',
	// 開戶審批查詢
	getAuditList: 'admin/getAuditList',
	// 審批狀態查詢接口
	getAdminRemarks: 'admin/getAdminRemarks',
	// 審批記錄查詢接口
	getAuditTrail: '/admin/getAuditTrail',
	// 審批記錄添加接口
	addAuditTrail: '/admin/addAuditTrail',
	// 管理員審批
	KhAdminAduit: 'admin/KhAdminAduit',
	// 根據開戶的唯一編碼獲取pdf文件
	getKHPdfData: 'admin/getKHPdfData',
	// 請求彈出開戶信息資料列表接口
	getOpeningList: 'admin/getOpeningList',
	getOpeningInfo: 'admin/getOpeningInfo',
	// 修改編號
	updateNewCode: 'admin/updateNewCode',
	//
	AdminGetMenuList: url + 'admin/getMenuList',
	getIpoSellingList: url + 'admin/getIpoSellingList',
	getUsMarketStockList: url + 'admin/getUsMarketStockList',
	//交易市场
	getParamList: url + 'admin/getParamList',

	//查詢接口  入錄信息
	getNewJbxx: url + 'admin/getNewJbxx',
	editNewJbxx: url + 'admin/editNewJbxx',
	newKhxxQt: url + 'admin/newKhxxQt',
	backendSubmit: url + 'admin/backendSubmit',
	//新增 
	newIpoSelling: url + 'admin/newIpoSelling',
	//新股認購單條記錄
	getIpoSellingById: url + 'admin/getIpoSellingById',
	//新股修改
	putuse: url + 'admin/updateIpoSellingById',
	//删除
	dropDelete: url + 'admin/dropIpoMsg',
	//列表排序
	sortHandle: url + 'admin/sortHandle',
	//熱門狀態
	HotStatus: url + 'admin/updateHotStatus',
	//審批
	ipoAdmin: url + 'admin/ipoAdminAduit',
	//審核狀態查詢
	getIpoAduitLogList: url + 'admin/getIpoAduitLogList',
	//pdf
	getKHPdfData: url + 'admin/getKHPdfData?id=',
	//客戶信息 列表
	getQmisUserList: url + 'admin/getQmisUserList',
	//审核记录查询接口
	getUserList: url + 'admin/getUserAduitLogList',
	newUserAduit: url + 'admin/newUserAduit',
	//图片
	getimg: url + 'admin/getMoneyOrderPic',
	//上传文件
	uploadPicwew: url + 'admin/uploadPicwew',
	//菜单
	dropTalkFAQTypeByTypeid:url + 'admin/dropTalkFAQTypeByTypeid',
	getGroups: url + 'admin/getIpoMissionOfScheduleGroups',
	editTalkFAQtype:url + 'admin/editTalkFAQtype',
	getstockstables: url +'admin/getIpoPicData',
	qmisgetTime: urls +'getTime',
	
	getStockMsg:urls + 'getStockMsg',
	//模拟交易
	trading: url+'papertrading/trading',
	portfolio:url +'papertrading/portfolio',
	//当日成交
	multiOrder:url + 'papertrading/multi_order_response',
	getOrderHistoryPdfs:url +'papertrading/getOrderHistoryPdf',
	
	
	//申请假期
	newApply: url + 'admin/newApply',
	getAttenceApplyList: url + 'admin/getAttenceApplyList',
	newreferenceval: url + 'papertrading/newreferenceval',
	// 歷史價格pdf
	getReferencevalPdf:url +'papertrading/getReferencevalPdf',
	getReferencevalExcel:url +'papertrading/getReferencevalExcel',
	//半仓
	getIpoWarehouse:url + 'papertrading/getIpoWarehouse',
	//审核  假期
	getAttenceApplyAuditLogList:url +'admin/getAttenceApplyAuditLogList',
	newAttenceApplyAudit:url +'admin/newAttenceApplyAudit',
	getAttenceApplyInfo:url +'admin/getAttenceApplyInfo',
	newOutRecordSummarize:url +'admin/newOutRecordSummarize',
	getDiscountingLog:url + 'papertrading/getDiscountingLog',
	
	// 假期paf
	getAttenceApplyPdf:url + 'admin/getAttenceApplyPdf',
	//提款存款
	newDiscounting:url +'papertrading/newDiscounting',
	//存記錄pdf
	getDiscountingLogPdf:url +'papertrading/getDiscountingLogPdf',
	//提存記錄exsel
	getDiscountingLogExcel:url+ 'papertrading/getDiscountingLogExcel',
	//修改密碼
	editUserPassword:url + 'papertrading/editUserPassword',
	//获取时间
	getUserMsg:url +'papertrading/getUserMsg',
	//POST 預加載pdf
	getpdfable:url + 'admin/getpdfable',
	//盈利（虧損）走勢
	getPlChartData:url + 'papertrading/getPlChartData',
	//薪增员工
	newEmployeeInfo:url + 'admin/newEmployeeInfo',
	getEmployeeList:url + 'admin/getEmployeeList',
	getEmployeeInfoPdf:url + 'admin/getEmployeeInfoPdf',
	getEmployeeInfo:url + 'admin/getEmployeeInfo',
	//的設定黨 個人詳細資料
	getPersonalInfo:url + 'admin/getPersonalInfo',
	//編輯
	editPersonalInfo:url + 'admin/editPersonalInfo',
	//登入詳細資料 查
	getPersonal:url + 'admin/getPersonalSecurityquestion',
	editPers:url + 'admin/editPersonalPasswordAndSecurityquestion',
	getSuperAdminInfo:url +'admin/getSuperAdminInfo',
	//登出
	logout:url +'admin/logout',
	getLoginLogList:url + 'admin/getLoginLogList',
	getAllRoleDetails:url + 'admin/getAllRoleDetails',
	getPdfs:url + 'admin/getStaffAnnualLeaveBalancePdf',
	//未提交戶
	getUnsubmittedKh:url + 'admin/getUnsubmittedKh',
	getExcel:url + 'admin/getUnsubmittedKhExcel',
	//域名
	newOther:url + 'admin/newOtherSystemManagement',
	getlsi:url + 'admin/getOtherSystemManagement',
	ditodate:url + 'admin/getOtherSystemManagementByid',
	deletOther:url+'admin/dropOtherSystemManagementByid',
	getlook:url+'admin/getOtherSystemManagementLog',
	//未提交戶
	getRevis:url + 'admin/getRevisitLogList',
	setedit:url + 'admin/editRevisit',
	getUnsk:url + 'admin/getUnsubmittedKhPdf',
	//導入接口 域名導入
	newOtherExcelAdd:url + 'admin/newOtherSystemManagementExcelAdd',
	// 客戶信息導入
	customerAdd:url + 'admin/customerInformationImport',
	// 邀請人列表查詢POST
	getKhIn:url + 'admin/getKhInviterList',
	editKh:url + 'admin/editKhInviter',
	// 推薦人已提交開戶列表
	getSubmit:url + 'admin/getSubmittedKhListByInviter',
	//推薦人未提交開戶列表
	getUnsubm:url + 'admin/getUnsubmittedKhListByInviter',
	//管理用户列表查询接口POST
	getAdminUserList:url + 'admin/getAdminUserList',
	//權限分配查詢POST
	getAuthor:url + 'admin/getAuthorizationList',
	newAuthor:url + 'admin/newAuthorization',
	editAdmin:url + 'admin/editAdminUser',
	newAdminUser:url + 'admin/newAdminUser',
	
	SubmittedKh:url + 'admin/getSubmittedKhListByInviterExcel',
	Unsubmit:url +'admin/getUnsubmittedKhListByInviterExcel',
	getQmis:url +'admin/getQmisAdministrativeContractList',//getQmisAdministrativeContractList//getkhadministrativeContractList
	adminbank:url +'admin/getQmisBankInfoList',
	newBankInfo:url+'admin/newBankInfo',
	getparas : url + 'admin/getParamList',
	getQmisBankInfo:url + 'admin/getQmisBankInfo',
	newQmis:url + 'admin/newQmisAdministrativeContract',
	getitem:url + 'admin/getQmisAdministrativeContract',
	getFirstidList:url + 'admin/getFirstidList',
	getAuthorizationList:url + 'admin/getAuthorizationList',
	getQmisBankInfoPdf:url + 'admin/getQmisBankInfoPdf',
	uploadPrice:url + 'admin/uploadPriceExcelFile',
	IpoPrice:url + 'admin/getIpoPriceList',
	TalkOnline:url + 'admin/getTalkOnlineUsers',
	//
	getTalkFAQ:url + 'admin/getTalkFAQ',
	TalkFAQtype:url + 'admin/newTalkFAQtype',
	newTalkFAQ:url + 'admin/newTalkFAQ',
	TalkingRoo:url + 'talk/getTalkingRoomRecord',
	//請求聊天列表
	RoomInUse:url + 'admin/getRoomInUse',
	//關閉
	closeTalkRoom:url + 'admin/closeTalkRoom',
	//帶跟進
	beFollowedRoom:url + 'admin/beFollowedRoom',
	//圖片上傳 base64
	uploadImage:url + 'talk/uploadImage',
	//聊天記錄
	getTalkingRoomRecord:url +'talk/getTalkingRoomRecord',
	getTalkingRecord:url +'admin/getTalkingRecord',
	startNewTalk:url + 'admin/startNewTalk',
	TradeDetail:url + 'admin/getUserTradeDetail',
	editQmisUserMsg:url + 'admin/editQmisUserMsg',
	//客户信息
	newFileInputHandle:url + 'admin/newFileInputHandle',
	OtcFileAuditByList:url + 'admin/OtcFileAuditByList',
	getParamList:url + 'admin/getParamList',
	getUserFilepdf:url + 'admin/getUserFilepdf',
	getQmisUserMsgList:url + 'admin/getQmisUserMsgList',
	getQmisUserMsgWithUsername:url + 'admin/getQmisUserMsgWithUsername',
	getQmisUserFileInfoPdf:url + 'admin/getQmisUserFileInfoPdf',
	stopUserFileUse:url + 'admin/stopUserFileUse',
	changeQmisUserStatus:url + 'admin/changeQmisUserStatus',
	
	getUserFileMissionsDetail:url + 'admin/getUserFileMissionsDetail',
	newUserFileAudit:url + 'admin/newUserFileAudit',

	editQmisUserMsgFilePage:url + 'admin/editQmisUserMsgFilePage',

	getUserFileStatusDetail:url + 'admin/getUserFileStatusDetail',
	clearUserKhMsg:url + 'admin/clearUserKhMsg',
	getUserTradeAuditDetails:url + 'admin/getUserTradeAuditDetails',
	getUserTradeAuditHistoryLog:url + 'admin/getUserTradeAuditHistoryLog',
	getQmisUserTCRecordPdf:url + 'admin/getQmisUserTCRecordPdf',
	getUsMarketStockWithUsStockid:url + 'admin/getUsMarketStockWithUsStockid',
	saveUsMarketStock:url + 'admin/saveUsMarketStock',
	getMoneytoHKDRate:url + 'admin/getMoneytoHKDRate',
	editMoneytoHKDRate:url + 'admin/editMoneytoHKDRate',
	newUsMarketStock:url + 'admin/newUsMarketStock',
	newUsMarketAudit:url + 'admin/newUsMarketAudit',
	getUsMarketAuditLogWithUsStockid:url + 'admin/getUsMarketAuditLogWithUsStockid',
	getHolidayCalculation:url + 'admin/getHolidayCalculation',
	newStockdividends:url + 'admin/newStockdividends',
	getQmisUserStockDividendsList:url + 'admin/getQmisUserStockDividendsList',
	getStockdividendsDataWithAuditid:url + 'admin/getStockdividendsDataWithAuditid',
	newStockdividendsAudit:url + 'admin/newStockdividendsAudit',
	getQmisUserStockDividendsPdf:url + 'admin/getQmisUserStockDividendsPdf',
	
	newEmailRecord:url + 'admin/newEmailRecord',
	uploadEmailsWithExcel:url + 'admin/uploadEmailsWithExcel',
	getEmailRecordList:url + 'admin/getEmailRecordList',
	uploadEmailsWithExcel:url + 'admin/uploadEmailsWithExcel',
	getEmailRecordWithEmailid:url + 'admin/getEmailRecordWithEmailid',
	resendEmail:url + 'admin/resendEmail',
	getEmailRecordPdf:url + 'admin/getEmailRecordPdf',
	getHolidayList: url + 'kaihu/getHolidayList',
	newJbxxYuYueTime: url + 'admin/newJbxxYuYueTime',
	newWebYuyue2: url + 'kaihu/newWebYuyue2',
	getKHLogOperation: url + 'admin/getKHLogOperation',
	getKHLogPDF: url + 'admin/getKHLogPDF',
	getKHErrorLogPDF: url + 'admin/getKHErrorLogPDF',
	downLoadKHLogPDF: url + 'admin/downLoadKHLogPDF',
	getTransactionLog: url + 'admin/getTransactionLog',
	getTransactionLogPDF: url + 'admin/getTransactionLogPDF',
	downLoadTransactionLogPDF: url + 'admin/downLoadTransactionLogPDF',
	getTransactionErrorLogPDF: url + 'admin/getTransactionErrorLogPDF',
	// 股票点击列表数据
	getStockClick: url + 'admin/getStockClick',
	getDailyLineChart: url + 'admin/getDailyLineChart',
	getMonthlyLineChart: url + 'admin/getMonthlyLineChart',
	getQuarterlyLineChart: url + 'admin/getQuarterlyLineChart',
	getYearlyLineChart: url + 'admin/getYearlyLineChart',
	getWeeklyLineChart: url + 'admin/getWeeklyLineChart',
	// 开户日志pdf
	exportKHLogPDF:url + 'admin/exportKHLogPDF',
	// 交易日志pdf
	exportTransactionLogPDF:url + 'admin/exportTransactionLogPDF',
	// 股票点击pdf
	exportStockClickPDF:url + 'admin/exportStockClickPDF',
	// 操作記錄pdf
	operationPersonLogPDF:url + 'admin/operationPersonLogPDF',
	exportOperationLogPDF:url + 'admin/exportOperationLogPDF',

	// 提存兑换
	getBankCodeAndName:url + 'admin/getBankCodeAndName',
	addDepositExchange:url + 'admin/addDepositExchange',
	// 证券账号搜索
	getSecurityAccount:url + 'admin/getSecurityAccount',
	// 在线开户导出pdf
	downLoadOpenAccountPDF:url + 'admin/downLoadOpenAccountPDF',
	downLoadOpenAccountExcel:url + 'admin/downLoadOpenAccountExcel',
	exportCustomerExcel:url + 'admin/exportCustomerExcel',
	getCustomerCountryOfResidence:url + 'admin/getCustomerCountryOfResidence',


	addFund:url + 'admin/addFund',
	saveFund:url + 'admin/saveFund',
	getFunds:url + 'admin/getFunds',
	getFundById:url + 'admin/getFundById',
	fundSubscriptionExamine:url + 'admin/fundSubscriptionExamine',
	fundMission:url + 'admin/fundMission',
	getReviewStatus:url + 'admin/getReviewStatus',
	deleteFundById:url + 'admin/deleteFundById',

	getBonds:url + 'admin/getBonds',
	getBondById:url + 'admin/getBondById',
	submitBondSubscription:url + 'admin/submitBondSubscription',
	saveBondSubscription:url + 'admin/saveBondSubscription',
	bondMissionCount:url + 'admin/bondMissionCount',
	getBondReviewStatus:url + 'admin/getBondReviewStatus',
	bondSubscriptionExamine:url + 'admin/bondSubscriptionExamine',
	deleteBondById:url + 'admin/deleteBondById',
	getBondIssuingInstitution:url + 'admin/getBondIssuingInstitution',
	addAccountOpeningInformation:url + 'admin/addAccountOpeningInformation',
	cancelAccountOpening:url + 'admin/cancelAccountOpening',
	freezeCustomerAccount:url + 'admin/freezeCustomerAccount',
	importDepositAndExchange:url + 'admin/importDepositAndExchange',
	updateBankContactPerson:url + 'admin/updateBankContactPerson',
	openingAccountImport:url + 'admin/openingAccountImport',
	exportAmountTable:url + 'admin/exportAmountTable',
	exportTradingPlatformExcel:url + 'admin/exportTradingPlatformExcel',
	getInvestQuestionnaireInfo:url + 'admin/getInvestQuestionnaireInfo',
	getRPQInfoByUsername:url + 'admin/getRPQInfoByUsername',
	getEntrustList:url + 'admin/getEntrustList',
	importFundSubscription:url + 'admin/importFundSubscription',
	importBondSubscription:url + 'admin/importBondSubscription',
	exportFundSubscriptionExcel:url + 'admin/exportFundSubscriptionExcel',
	exportFundSubscriptionPDF:url + 'admin/exportFundSubscriptionPDF',
	getFundSubscriptionBuy:url + 'admin/getFundSubscriptionBuy',
	getFundOrderDetailById:url + 'admin/getFundOrderDetailById',
	auditFundSubscriptionOrder:url + 'admin/auditFundSubscriptionOrder',
	getBondSubscriptionBuy:url + 'admin/getBondSubscriptionBuy',
	getBondOrderDetailById:url + 'admin/getBondOrderDetailById',
	auditBondSubscriptionOrder:url + 'admin/auditBondSubscriptionOrder',
	fundByRecordsMission:url + 'admin/fundByRecordsMission',
	bondByRecordsMission:url + 'admin/bondByRecordsMission',
	getFundBuyStatus:url + 'admin/getFundBuyStatus',
	getBondBuyStatus:url + 'admin/getBondBuyStatus',
	exportBondProductsExcel:url + 'admin/exportBondProductsExcel',
	exportBondProductsPDF:url + 'admin/exportBondProductsPDF',
	getIOQAuditInterface:url + 'admin/getIOQAuditInterface',
	getSignRPQInfo:url + 'admin/getSignRPQInfo',
	getInvestOrientationQuestionnairePDF:url + 'admin/getInvestOrientationQuestionnairePDF',
	questionnaireAudit:url + 'admin/questionnaireAudit',
	signRPOQuestionnaire:url + 'admin/signRPOQuestionnaire',
	getCustomerFileAuditStatus:url + 'admin/getCustomerFileAuditStatus',
	exportDepositAndExchange:url + 'admin/exportDepositAndExchange',
	exportStockClickExcel:url + 'admin/exportStockClickExcel',
	exportOpenAccountLogExcel:url + 'admin/exportOpenAccountLogExcel',
	exportTransactionLogExcel:url + 'admin/exportTransactionLogExcel',
	administrativeContract:url + 'exportExcel/administrativeContract',
	bankInformation:url + 'exportExcel/bankInformation',
	operationRecords:url + 'exportExcel/operationRecords',
	domainNameContract:url + 'exportExcel/domainNameContract',
	systemContract:url + 'exportExcel/systemContract',
	developmentPlatform:url + 'exportExcel/developmentPlatform',
	unSubmittedAccount:url + 'exportExcel/unSubmittedAccount',
	importAdministrativeContractExcel:url + 'importExcel/importAdministrativeContractExcel',
	importBankInformationExcel:url + 'importExcel/importBankInformationExcel',
	importDomainNameContractExcel:url + 'importExcel/importDomainNameContractExcel',
	importSystemContractExcel:url + 'importExcel/importSystemContractExcel',
	exportEmployeeInformationPDF:url + 'exportPDF/exportEmployeeInformationPDF',
	exportEmployeeInformationExcel:url + 'exportExcel/exportEmployeeInformationExcel',
	exportAddInvitationPDF:url + 'exportPDF/exportAddInvitationPDF',
	exportAddInvitationExcel:url + 'exportExcel/exportAddInvitationExcel',
	exportHongHongStockExcel:url + 'exportExcel/exportHongHongStockExcel',
	exportHongKongStockPDF:url + 'exportPDF/exportHongKongStockPDF',
	importHongKongStocksExcel:url + 'importExcel/importHongKongStocksExcel',
	getInvestment:url + 'admin/getInvestment',
	addInvestment:url + 'admin/addInvestment',
	auditInvestment:url + 'admin/auditInvestment',
	removeInvestmentByIds:url + 'admin/removeInvestmentByIds',
	buyOrSellInvestmentProductById:url + 'admin/buyOrSellInvestmentProductById',
	getTradeRecords:url + 'admin/getTradeRecords',
	exportEntrustListPDF:url + 'admin/exportEntrustListPDF',
	exportEntrustListExcel:url + 'admin/exportEntrustListExcel',
	exportEntrustInvestPDF:url + 'admin/exportEntrustInvestPDF',
	exportEntrustInvestExcel:url + 'admin/exportEntrustInvestExcel',
	importEntrustInvestExcel:url + 'admin/importEntrustInvestExcel',
	getAuditRecords:url + 'admin/getAuditRecords',
	exportEntrustTradeRecordsPDF:url + 'admin/exportEntrustTradeRecordsPDF',
	// 全權委託
	getEntrustInfo:url + 'admin/getEntrustInfo',
	addEntrustAudit:url + 'admin/addEntrustAudit',
	auditEntrust:url + 'admin/auditEntrust',
	getEntrustAuditRecords:url + 'admin/getEntrustAuditRecords',




	

}
